import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();

  return (
    <footer className="border-t border-surface-subtle bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm text-ink-muted sm:flex-row sm:px-6 lg:px-8">
        <div className="flex items-center gap-2">
          <img src="/logo_background_removed.png" alt="Sport Sphere" className="h-6 w-auto" />
          <span className="font-semibold text-ink">Sport Sphere</span>
        </div>
        <nav className="flex items-center gap-4">
          <Link to="/feedback" state={{ from: location.pathname }} className="hover:text-ink">
            Send feedback
          </Link>
          <Link to="/submit-event" className="hover:text-ink">
            Submit an event
          </Link>
          <Link to="/privacy" className="hover:text-ink">
            Privacy
          </Link>
        </nav>
        <p>&copy; {new Date().getFullYear()} Sport Sphere</p>
      </div>
    </footer>
  );
}
